import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';
import VideoPlayer from '@bd/bdui-videoplayer';
import LightBox from '@bd/bdui-lightbox';
import Carousel from '../../components/CarouselDetailsPages';

const styles = css`
  position: relative;
  align-items: center;
  .HomeHeader_mainImage {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  .HomeHeader_title {
    position: relative;
    z-index: 1;
    margin: 0;
    font-weight: 700;
    font-size: 32px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: center;
    line-height: 45px;
    @media(min-width: 992px) {
      font-size: 70px;
      font-weight: bold;
      letter-spacing: 1.03px;
      line-height: 70px;
      text-align: center;
      text-shadow: 0 4px 11px 0 rgba(0,0,0,0.7), 0 3px 16px 0 rgba(0,0,0,0.8);
    }
  }
  .HomeHeader_buttonHolder {
    @media (min-width: 992px) {
      display: none;
    }
    display: inline-flex;
    position: absolute;
    right: 10px;
    bottom: 10px;
    height: 35px;
  }
  .HomeHeader_tour {
    @media (min-width: 992px) {
      display: none;
    }
    .HomeHeader_tourButton {
      background-image: url('/images/icons/tour.svg');
      background-repeat: no-repeat;
      height: 35px;
      background-color: rgba(0, 144, 210, 0.82);
      width: 45px;
      background-position-x: 10px;
      background-position-y: 8px;
    }
  }
  .HomeHeader_photos {
    @media (min-width: 992px) {
      display: none;
    }
    .HomeHeader_photosButton {
      height: 35px;
      cursor: pointer;
      display: inline-flex;
      .left {
        background-image: url('/images/icons/expend.svg');
        height: 100%;
        width: 32px;
        content: '';
        background-repeat: no-repeat;
        background-position-y: 8px;
        background-position-x: 10px;
        background-color: rgba(0, 0, 0, 0.82);
      }
      .right {
        height: 100%;
        width: 42px;
        color: #FFFFFF;
        font-size: 16.2px;
        font-weight: 800;
        line-height: 16px;
        text-align: center;
        padding-top: 9px;
        background-color: #000;
      }
    }
  }
  .HomeHeader_videos {
    @media (min-width: 992px) {
      display: none;
    }
    .HomeHeader_videosButton {
      background-image: url('/images/icons/youtube-white.svg');
      background-repeat: no-repeat;
      height: 35px;
      background-color: rgba(57, 57, 57, 0.9);
      width: 45px;
      background-size: 25px;
      background-position-x: 10px;
      background-position-y: 8px;
    }
  }
`;

const videosCss = css`
  margin: 10vh auto 0;
  @media (min-width: 992px) {
    width: 75vw;
    margin: 10vh auto 0;
  }
`;

const videoLightBoxStyle = css`
  position: relative;
  width: 80%;
  padding-top: calc(80% * 0.5625);
  margin-top: -22%;
  top: 50%;
  margin-left: 10%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

function HomeHeader({ home }) {
  let homePhotos = [];
  if (get(home, 'photos')) {
    homePhotos = get(home, 'photos').map((item, i) => ({
      caption: `${get(home, 'address.addressLocality')} Photo-${i + 1}`,
      contentUrl: get(item, 'contentUrl'),
    }));
  }
  const mediaStyle = {};
  let photos = [];
  let tourUrl;
  // let videos = [];
  const samplePhotos = null;

  if (home) {
    photos = [
      ...homePhotos,
      ...get(home, 'elevationPhotos', []),
    ];
    tourUrl = get(home, 'tourUrl') ? get(home, 'tourUrl') : undefined;
    // samplePhotos = sample(homePhotos).contentUrl;
  }

  if (get(home, 'video')) {
    photos.splice(1, 0, {
      type: 'video',
      element: (<VideoPlayer controls className={`Carousel_imageElement ${videoLightBoxStyle}`} url={get(home, 'video_url')} light={photos[photos.length - 1].contentUrl} />),
      contentUrl: samplePhotos,
    });
  }

  if (tourUrl) {
    photos.splice(3, 0, {
      type: 'tour',
      element: (<div className={`Carousel_imageElement ${videoLightBoxStyle}`}><iframe title="Virtual Tour" src={tourUrl} /></div>),
      contentUrl: samplePhotos,
    });
  }

  return (
    <div className={styles}>
      <div className="HomeHeader_mainImage" style={mediaStyle} >
        <Carousel
          items={photos}
          thumbnails
          mainImageProps={{
            width: 2000,
            height: 1125,
            exact: true,
          }}
          thumbnailImageProps={{
            width: 475,
            height: 267,
            exact: true,
          }}
        />
        <div className="HomeHeader_buttonHolder">
          {
            get(home, 'video') &&
            <LightBox
              className="HomeHeader_videos"
              items={[
                {
                  element: (
                    <div
                      className={`${videosCss} embed-responsive embed-responsive-16by9`}
                      dangerouslySetInnerHTML={SanitizeHtml(get(home, 'video'))}
                    />
                  ),
                },
              ]}
            >
              <div className="HomeHeader_videosButton mr-2" />
            </LightBox>
          }
          {
            tourUrl &&
            <LightBox
              className="HomeHeader_tour"
              items={[{
                element: (
                  <iframe
                    className="interactive_plan"
                    src={tourUrl}
                    title="interactivePlan"
                    width="100%"
                    height="100%"
                  />
                ),
              }]}
              button={(
                <div className="HomeHeader_tourButton mr-2" />
              )}
            />
          }
          {
            photos.length &&
            <div className="HomeHeader_photos">
              <LightBox
                items={photos}
                button={(
                  <div className="HomeHeader_photosButton">
                    <span className="left" />
                    <span className="right">{`+${photos.length}`}</span>
                  </div>
                )}
              />
            </div>
          }
        </div>
      </div>
    </div>
  );
}

HomeHeader.propTypes = {
  home: PropTypes.object.isRequired,
};

export default HomeHeader;



// WEBPACK FOOTER //
// ./src/pages/HomeDetail/HomeHeader.js